import './Vendors';
import './Api';

import { initializeSignage } from '../../Signage/initialize';
import { autosizeImage, round } from '../../Widget/AnnouncementWidget/Announcements';

declare global {
    interface Window {
        initializeSignage: typeof initializeSignage;
        announcementUtilities: {
            round: typeof round;
            autosizeImage: typeof autosizeImage;
        };
    }
}

window.initializeSignage = initializeSignage;
window.announcementUtilities = {
    round,
    autosizeImage,
};
